export const SET_ORM = 'orm/SET_ORM';
export const CLEAR = 'orm/CLEAR';
